import { is, mergeWith } from 'ramda'

const mergeable = is(Object)
const deepMerge = (a, b) =>
  mergeable(a) && mergeable(b) ? mergeWith(deepMerge, a, b) : b

export default deepMerge
